import type { RestartBlocker } from "@shared/lib/desktop";

/** Пароль намеренно не передаётся в blocker и нигде не сохраняется. */
export function authRestartBlocker(dirty: boolean, submitting: boolean): RestartBlocker | null {
  if (!dirty && !submitting) return null;

  return {
    id: "auth-form",
    title: submitting ? "Выполняется вход" : "Заполнена форма входа",
    detail: submitting
      ? "дождитесь ответа сервера перед обновлением"
      : "завершите вход или очистите поля — пароль не сохраняется",
    kind: "wait",
  };
}
